<template>
    <div>
        <div class="progress h-100 mb-2">
            <div class="progress-bar bg-success pl-2" v-bind:style="{height: 25+'px', width: ((currentQuestion+1)/questionCount)*100 + '%'}" role="progressbar">
                Frage: {{currentQuestion+1}} / {{questionCount}}
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <h2>{{question.text}}</h2>
            </div>
            <div class="card-body">
                <p>
                    <slot>
                        <choices v-bind:choices="choices" v-bind:answersSaved="answersSaved"
                                 v-on:handleChoiceChange="handleChoiceUpdate($event)">

                        </choices>
                    </slot>
                </p>
            </div>
            <div class="card-footer">
                <div class="row">
                    <div class="col-4">
                        <button class="btn btn-success pull-left"
                                v-on:click="$emit('previous-question')"
                        >
                            vorherige Frage
                        </button>
                    </div>
                    <div class="col-4 text-center">
                        <test-pager
                            v-bind:currentQuestion="currentQuestion"
                            v-bind:range=3
                            v-bind:max="questionCount"
                            v-on:setCurrentQuestion="handleSetQuestionId($event)"
                        ></test-pager>
                    </div>
                    <div class="col-4">
                        <button v-if="!isLast" class="btn btn-success pull-right"
                                v-on:click="$emit('next-question')"
                        >
                            nächste Frage
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        data() {
            return {
                'answers': []
            }
        },
        props: [
            'question', 'choices', 'isLast', 'currentQuestion', 'questionCount', 'answersSaved'
        ],
        methods: {
            handleChoiceUpdate: function (answers) {
                this.answers = answers;
                this.$emit('handleAnswerChange', {'answers': this.answers, 'questionId': this.question.id});
            },
            handleSetQuestionId(id) {
                this.$emit('setCurrentQuestion', id);
            }
        },
    }
</script>
